import { render, staticRenderFns } from "./DeviceDetailsPage.vue?vue&type=template&id=23101021&"
import script from "./DeviceDetailsPage.vue?vue&type=script&lang=js&"
export * from "./DeviceDetailsPage.vue?vue&type=script&lang=js&"
import style0 from "./DeviceDetailsPage.vue?vue&type=style&index=0&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports